<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>사전예약 수정</strong>
          </div>
          <b-form v-on:submit.prevent="submitHandling">
            <b-form-group
              label="게임"
              label-for="appMasterId"
              :label-class="labelClasses+` zzz`"
              invalid-feedback="게임을 선택하세요."
              :state="appMasterIdState">
              <b-form-input id="appMasterId"
                            :state="appMasterIdState"
                            :value="preg.appInfo.appName"
                            readonly>
                <!--v-on:change="appChangeHandler"-->
              </b-form-input>
            </b-form-group>

            <b-form-group
                    label="장르"
                    :label-class="labelClasses+` zzz`">
              <b-form-input
                            :value="genreDesc[preg.appInfo.genre] ? genreDesc[preg.appInfo.genre]['ko'] : 'unknown'"
                            readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
                    label="개발사명"
                    :label-class="labelClasses+` zzz`">
              <b-form-input
                            :value="preg.appInfo.partnerName"
                            readonly>
                <!--v-on:change="appChangeHandler"-->
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="종류"
              label-for="type"
              :label-class="labelClasses"
              invalid-feedback="종류를 선택하세요"
              :state="typeState" v-if="this.isInhouseLogin()">
              <b-form-select id="type"
                             :options="pregTypeOptionsForBootstrap"
                             v-model="preg.type" :state="typeState">
              </b-form-select>
            </b-form-group>
            <b-form-group
              description=""
              label="제목"
              label-for="name"
              :label-class="labelClasses" :state="nameState"
              invalid-feedback="제목을 입력하세요." v-if="this.isInhouseLogin()">
              <b-form-input id="name" type="text" autocomplete="name" v-model="preg.name" :state="nameState"></b-form-input>
            </b-form-group>
            <b-form-group
              label="마켓"
              label-for="os"
              :label-class="labelClasses" invalid-feedback="마켓을 선택하세요." :state="marketState" v-if="this.isInhouseLogin()">
              <b-form-checkbox-group v-model="preg.markets" :options="marketTypeOptionsForBootstrap">
              </b-form-checkbox-group>
            </b-form-group>

            <b-form-group
                    label="사전예약 주소**"
                    label-for="preg.permaUri"
                    :label-class="labelClasses" v-if="this.isInhouseLogin()">
              <div class="custom-control custom-checkbox mb-3" style="margin-top: -8px;">
                <input type="checkbox" class="custom-control-input" id="preg.allowInBoundConn" v-model="preg.etcInfo.allowInBoundConn">
                <!--<input type="checkbox" class="custom-control-input" id="ios" value="ios" checked>-->
                <label class="custom-control-label" for="preg.allowInBoundConn">사전예약 상세 보기 허용 (체크시, 사전예약 진행 여부와 상관 없이 상세 페이지 노출)</label>
              </div>
            </b-form-group>

            <label :class="labelClasses" v-if="this.isInhouseLogin()">예약 기간</label>
            <b-form-group
              label="시작"
              label-for="startTime" :horizontal="true" :label-cols="1" invalid-feedback="예약 기간을 설정해주세요." :state="startTimeState" v-if="this.isInhouseLogin()">
              <date-picker id="startTime" :value="preg.startTime" v-on:input="preg.startTime = new Date($event)" :config="dateOptions"></date-picker>
            </b-form-group>
            <b-form-group
              label="종료"
              label-for="endTime" :horizontal="true" :label-cols="1" :invalid-feedback="endTimeFeedBack" :state="endTimeState" v-if="this.isInhouseLogin()">
              <date-picker id="endTime" :value="preg.endTime" v-on:input="preg.endTime = new Date($event)" :config="endOptions"></date-picker>
            </b-form-group>
            <b-form-group
              label="이모티콘 보상 설정"
              label-for="emoticonReward"
              :label-class="labelClasses" v-if="this.isInhouseLogin()">
              <b-form-radio-group v-model="emoticonSelected" v-on:change="emoticonSelectedHandler">
                <b-form-radio value="n">없음</b-form-radio>
                <b-form-radio value="y">이모티콘 api key</b-form-radio>
                <span v-show="emoticonSelected==='y'">
                  <b-form-input id="emoticonReward" type="text" v-model="preg.etcInfo.emoticonApiKey" autocomplete="emoticonApiKey" :class="` d-inline-block w-50 align-middle mr-1`"></b-form-input>
                  <b-button type="button" class="btn btn-sm btn-secondary" @click="chkEmoticonValidation">유효성 체크</b-button>
                </span>
              </b-form-radio-group>
              <p class="text-danger" v-show="emoticonSelected==='y'">
                <span v-show="emoticonValidation" style="color:#008000;">! 유효합니다. </span>
                <span v-show="!emoticonValidation">! 이모티콘 api key값 입력 후 유효성 체크를 누르세요.</span>
              </p>
            </b-form-group>

            <b-form-group
                    label="톡채널 설정"
                    label-for="plusFriend"
                    :label-class="labelClasses" v-if="this.isInhouseLogin()">
              <b-form-radio-group v-model="preg.etcInfo.plusFriend" v-on:change="plusFriendSelectedHandler">
                <b-form-radio :value="false">사용안함</b-form-radio>
                <b-form-radio :value="true">사용함 (게임관리>톡채널 등록/조회에서 이미 등록한 경우 사용 가능)</b-form-radio>
              </b-form-radio-group>
              <p class="text-dark" v-show="preg.etcInfo.plusFriend === true">
                {{ '톡채널명 : ' + plusFriendInfo.title }}
              </p>
            </b-form-group>

            <b-form-group
              label="체험 플레이 / 브랜드 페이지 설정"
              label-for="sampleSnackAddr"
              :label-class="labelClasses" v-if="this.isInhouseLogin()">
              <b-form-radio-group v-model="sampleSnackSelected" v-on:change="removeProperty(preg.etcInfo, 'sampleSnackAddr');removeProperty(preg.etcInfo, 'brandPageAddr')">
                <b-form-radio value="n">없음</b-form-radio>
                <b-form-radio value="play">체험플레이 주소</b-form-radio>
                <b-form-radio value="brand">브랜드페이지 주소</b-form-radio>
                <span v-show="sampleSnackSelected === 'play'">
                  <b-form-input id="sampleSnackAddr" :state="isUrl(preg.etcInfo.sampleSnackAddr)" type="text" autocomplete="url" v-model="preg.etcInfo.sampleSnackAddr" :class="` d-inline-block w-50 align-middle mr-1`"
                                placeholder="http:// 혹은 https://로 시작해주세요."></b-form-input>
                  <b-button type="button" class="btn btn-sm btn-secondary" :href="preg.etcInfo.sampleSnackAddr" target="_blank">링크 확인</b-button>
                </span>
                <span v-show="sampleSnackSelected === 'brand'">
                  <b-form-input id="sampleSnackAddr" :state="isUrl(preg.etcInfo.brandPageAddr)" type="text" autocomplete="url" v-model="preg.etcInfo.brandPageAddr" :class="` d-inline-block w-50 align-middle mr-1`"
                                placeholder="http:// 혹은 https://로 시작해주세요."></b-form-input>
                  <b-button type="button" class="btn btn-sm btn-secondary" :href="preg.etcInfo.brandPageAddr" target="_blank">링크 확인</b-button>
                </span>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              label="커뮤니티 설정"
              label-for="cafeTalkAddr"
              :label-class="labelClasses" v-if="this.isInhouseLogin()">
              <b-form-radio-group v-model="cafeTalkSelected">
                <b-form-radio value="n" v-on:change="removeProperty(preg.etcInfo, 'cafeTalkAddr')">비공개</b-form-radio>
                <b-form-radio value="y">공개</b-form-radio>
                <span v-if="cafeTalkSelected==='y'">
                  <b-form-input id="cafeTalkAddr" type="text" :state="isUrl(preg.etcInfo.cafeTalkAddr)" autocomplete="url" v-model="preg.etcInfo.cafeTalkAddr" :class="` d-inline-block w-50 align-middle mr-1`" placeholder="다음카페 또는 카페톡 주소만 입력 가능합니다."></b-form-input>
                  <b-button class="btn btn-sm btn-secondary" :href="preg.etcInfo.cafeTalkAddr" target="_blank">링크 확인</b-button>
                </span>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              label="최대 예약자 설정"
              label-for="maxUserCount"
              :label-class="labelClasses" v-if="this.isInhouseLogin()">
              <b-form-radio-group v-model="maxUserCountSelected">
                <b-form-radio value="n" v-on:change="removeProperty(preg.etcInfo, 'maxUserCount')">무제한</b-form-radio>
                <b-form-radio value="y">제한 있음</b-form-radio>
                <b-form-select id="maxUserCount"
                               size="lg"
                               :options="maxUserCountOptions"
                               v-model="preg.etcInfo.maxUserCount"
                               :class="` d-inline-block w-50 align-middle mr-1`" v-if="maxUserCountSelected==='y'">
                </b-form-select>
              </b-form-radio-group>
            </b-form-group>
            <!--<b-form-group-->
              <!--label="게임 챗봇 설정"-->
              <!--label-for="chatBotId"-->
              <!--:label-class="labelClasses" v-if="this.isInhouseLogin()">-->
              <!--<b-form-radio-group v-model="chatBotIdSelected">-->
                <!--<b-form-radio value="n" v-on:change="removeProperty(preg.etcInfo, 'chatBotId')">없음</b-form-radio>-->
                <!--<b-form-radio value="y">플친 ID</b-form-radio>-->
                <!--<b-form-input id="chatBotId" type="text" v-model="preg.etcInfo.chatBotId" :class="` d-inline-block w-50 align-middle mr-1`" placeholder="예) @카카오게임" v-if="chatBotIdSelected==='y'"></b-form-input>-->
              <!--</b-form-radio-group>-->
            <!--</b-form-group>-->
            <b-form-group
              description=""
              label="게임 소개 (KO/EN/JP/CH)"
              label-for="detailSummary.ko"
              :label-class="labelClasses"
              invalid-feedback="게임 소개를 입력하세요." :state="detailSummaryState">
              <b-form-textarea id="detailSummary.ko"
                               v-model="preg.viewInfo.detailSummary.ko"
                               :rows="6"
                               :max-rows="6" :state="detailSummaryState">
              </b-form-textarea>
            </b-form-group>
            <b-form-group
              description=""
              label="사전 예약 안내 (이벤트 내용, 사전예약 보상 내용 등) (KO/EN/JP/CH)"
              label-for="detailDesc.ko"
              :label-class="labelClasses"
              invalid-feedback="사전 예약 안내를 입력하세요."
              :state="detailDescKoState">
              <b-form-textarea id="detailDesc.ko"
                               v-model="preg.viewInfo.detailDesc.ko"
                               :rows="6"
                               :max-rows="6" :state="detailDescKoState">
              </b-form-textarea>
            </b-form-group>
            <b-form-group
              description=""
              label="읽어 보세요. (KO/EN/JP/CH)"
              label-for="detailNotice.ko"
              :label-class="labelClasses"
              invalid-feedback="게임 소개를 입력하세요.">
              <b-form-textarea id="detailNotice.ko"
                               v-model="preg.viewInfo.detailNotice.ko"
                               :rows="3"
                               :max-rows="6">
              </b-form-textarea>
              <span style="color: #f00">하단의 카카오톡 메시지 관련 안내문구는 변경/삭제하지 말고 그대로 적용해주세요.</span>
            </b-form-group>
            <b-form-group
              description=""
              label="사전 테스트 안내 (KO/EN/JP/CH)"
              label-for="detailCbtNotice"
              :label-class="labelClasses"
              invalid-feedback="게임 소개를 입력하세요.">
              <b-form-radio-group v-model="cbtSelected">
                <b-form-radio value="n" v-on:change="resetCbt('ko')">없음</b-form-radio>
                <b-form-radio value="y" v-on:change="setDefaultCbt('ko')">있음</b-form-radio>
                <span v-if="cbtSelected === 'y'">
                  <b-form-group class="d-inline-block"
                                label="테스트 시작일 설정"
                                label-for="cbtStartDate" :horizontal="true" label-cols="5">
                    <date-picker id="cbtStartDate" :value="preg.cbtMsgInfo !== null ? (preg.cbtMsgInfo.cbtStartDate) : null" v-on:input="preg.cbtMsgInfo.cbtStartDate = new Date($event)" :config="dateOptions"></date-picker>
                  </b-form-group>
                  <b-form-group label="내용" label-for="detailCbtNotice.ko" v-if="cbtSelected === 'y'" :state="detailCbtNoticeKoState" invalid-feedback="사전테스트 안내 메시지를 입력해주세요.">
                    <b-form-textarea id="detailCbtNotice.ko"
                                     v-model="preg.viewInfo.detailCbtNotice.ko"
                                     :rows="3"
                                     :max-rows="6" :state="detailCbtNoticeKoState">
                    </b-form-textarea>
                  </b-form-group>
                </span>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              description=""
              label="스킨형 소재 (KO/EN/JP/CH)"
              :label-class="labelClasses">
              <b-form-group class="d-inline-block mb-0"
                            label="스킨 이미지" label-for="detailTopBgImage" invalid-feedback="스킨 이미지를 추가하세요." :state="detailTopBgImageState">
              </b-form-group>
              <div style="width: 336px;">
                <vue-dropzone ref="detailTopBgImage" id="detailTopBgImage" :options="Object.assign({}, dropzoneOptions, {clickable: ['#detailTopBgImage', '#detailTopBgImageUploadBtn'], maxFilesize: 0.2, renameFile: renameAndSetDtoProperty.bind(this, { lang: 'ko', name: 'detailTopBgImage', imageObj: 'viewInfo' }), accept: acceptHandlingForDimensionLimit.bind(this, 1536, 984, '스킨 이미지')})" v-on:vdropzone-success="imgSuccessHandling"
                              v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-error="imgErrorHandling" v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" v-on:vdropzone-sending="$refs['detailTopBgImage'].removeAllFiles(false);$refs['detailTopBgImage'].setOption('maxFiles', null)" class="mb-2"></vue-dropzone>
                <span class="hilight">1536 x 984, 200kb 이하</span>
              </div>
              <div>
                <b-button type="button" :id="'detailTopBgImageUploadBtn'">upload</b-button>
                <b-button type="button" :href="preg.viewInfo.detailTopBgImage.ko" v-if="preg.viewInfo.detailTopBgImage.ko" class="ml-3" target="_blank">download</b-button>
              </div>

              <br>

              <b-form-group class="d-inline-block mb-0 mt-3"
                            label="프로모션 이미지" label-for="detailTopPromoImage" invalid-feedback="프로모션 이미지를 추가하세요." :state="detailTopPromoImageState">
              </b-form-group>
              <div style="width: 336px;" class="mb-3">
                <vue-dropzone ref="detailTopPromoImage" id="detailTopPromoImage" :options="Object.assign({}, dropzoneOptions, {clickable: ['#detailTopPromoImage', '#detailTopPromoImageUploadBtn'], maxFilesize: 0.2, renameFile: renameAndSetDtoProperty.bind(this, { lang: 'ko', name: 'detailTopPromoImage', imageObj: 'viewInfo'}), accept: acceptHandlingForDimensionLimit.bind(this, 1436, 1910, '프로모션 이미지')})" v-on:vdropzone-success="imgSuccessHandling"
                              v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-error="imgErrorHandling" v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" v-on:vdropzone-sending="$refs['detailTopPromoImage'].removeAllFiles(false);$refs['detailTopPromoImage'].setOption('maxFiles', null)" class="mb-2"></vue-dropzone>
                <span class="hilight">1436 x 1910, 200kb 이하</span>
              </div>
              <div>
                <b-button type="button" :id="'detailTopPromoImageUploadBtn'">upload</b-button>
                <b-button type="button" :href="preg.viewInfo.detailTopPromoImage.ko" v-if="preg.viewInfo.detailTopPromoImage.ko" class="ml-3" target="_blank">download</b-button>
              </div>

              <br>

              <b-form-group label="스킨 색상" horizontal label-cols="1" style="word-break: keep-all" invalid-feedback="스킨 색상을 입력하세요." :state="detailTopBgColorState">
                <b-form-radio-group v-model="detailTopBgColorSelected">
                  <b-form-radio value="#fff" v-on:change="addProperty(preg.viewInfo, 'detailTopBgColor', '#fff')">white</b-form-radio>
                  <b-form-radio value="#000" v-on:change="addProperty(preg.viewInfo, 'detailTopBgColor', '#000')">black</b-form-radio>
                  <b-form-radio value="custom" v-on:change="removeProperty(preg.viewInfo, 'detailTopBgColor')">custom</b-form-radio>
                  <b-form-input id="detailTopBgColor" type="text" maxlength="7" :state="detailTopBgColorState" v-model="preg.viewInfo.detailTopBgColor" autocomplete="color" :class="` d-inline-block w-50 align-middle mr-1`" placeholder="" v-if="detailTopBgColorSelected==='custom'"></b-form-input>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group label="글자 색상" horizontal label-cols="1" style="word-break: keep-all" invalid-feedback="글자 색상을 입력하세요." :state="detailTextColorState">
                <b-form-radio-group v-model="preg.viewInfo.detailTextColor">
                  <b-form-radio value="#000">black</b-form-radio>
                  <b-form-radio value="#fff">white</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group label="강조/하이퍼링크 색상" horizontal label-cols="1" style="word-break: keep-all" :state="detailAnchorColorState" invalid-feedback="강조/하이퍼링크 색상을 입력하세요.">
                <b-form-radio-group v-model="detailAnchorColorSelected">
                  <b-form-radio value="#cc2105" v-on:change="addProperty(preg.viewInfo, 'detailAnchorColor', '#cc2105')">red(<span class="PregRectangle red"></span>)</b-form-radio>
                  <b-form-radio value="#f0e313" v-on:change="addProperty(preg.viewInfo, 'detailAnchorColor', '#f0e313')">yellow(<span class="PregRectangle yellow"></span>)</b-form-radio>
                  <b-form-radio value="#003cff" v-on:change="addProperty(preg.viewInfo, 'detailAnchorColor', '#003cff')">blue(<span class="PregRectangle blue"></span>)</b-form-radio>
                  <b-form-radio value="#d42cd6" v-on:change="addProperty(preg.viewInfo, 'detailAnchorColor', '#d42cd6')">purple(<span class="PregRectangle purple"></span>)</b-form-radio>
                  <b-form-radio value="custom" v-on:change="removeProperty(preg.viewInfo, 'detailAnchorColor')">custom</b-form-radio>
                  <b-form-input id="detailTopBgColor" type="text" :state="detailAnchorColorState" v-model="preg.viewInfo.detailAnchorColor" autocomplete="color" :class="` d-inline-block w-50 align-middle mr-1`" placeholder="" v-if="detailAnchorColorSelected==='custom'"></b-form-input>
                </b-form-radio-group>
                <p class="text-dark">
                  * 색상 코드 입력 예시: #f0e313
                </p>
              </b-form-group>
            </b-form-group>

            <b-form-group
                    description=""
                    label="닉네임 선점"
                    :label-class="labelClasses" v-if="this.isInhouseLogin()">
              <b-form-radio-group v-model="isUsingNicknamePreemption">
                <b-form-radio value="n">없음</b-form-radio>
                <b-form-radio value="y">있음</b-form-radio>
              </b-form-radio-group>

              <div v-show="this.isUsingNicknamePreemption==='y'">
                <div v-if="isUsingNicknamePreemption==='y'" class="d-flex flex-row mt-3">
                  <div class="d-flex flex-column" style="width: 400px">
                    <b-form-group class="d-inline-block"
                                  label="닉네임 선점 시작일 설정"
                                  label-for="nicknamePreemptionStartTime" :horizontal="true" :label-cols="5">
                      <date-picker id="nicknamePreemptionStartTime" :value="preg.pregNicknameEventInfo.startTime" v-on:input="preg.pregNicknameEventInfo.startTime = new Date($event)" :config="dateOptions" style="width: 200px"></date-picker>
                    </b-form-group>
                    <b-form-group class="d-inline-block"
                                  label="닉네임 선점 종료일 설정"
                                  label-for="nicknamePreemptionEndTime" :horizontal="true" :label-cols="5">
                      <date-picker id="nicknamePreemptionEndTime" :value="preg.pregNicknameEventInfo.endTime" v-on:input="preg.pregNicknameEventInfo.endTime = new Date($event)" :config="dateOptions" style="width: 200px"></date-picker>
                    </b-form-group>
                    <b-form-group class="d-inline-block"
                                  label="말풍선 표기"
                                  label-for="nicknamePreemptionSpeechBubble" :horizontal="true" :label-cols="5">
                      <b-form-input id="nicknamePreemptionSpeechBubble"  type="text" v-model="preg.pregNicknameEventInfo.speechBubble" @input="checkSpeechBubbleLength()" style="width: 200px"></b-form-input>
                    </b-form-group>
                    <p class="text-danger">* 말풍선은 20자 이하로 입력해주세요.</p>
                  </div>
                  <b-form-group class="d-flex align-items-end pb-4" >
                    <div v-if="isNicknamePreview" class="preview">
                      <span style="color: #F2591C">서버/캐릭터명 선점</span>
                      <span class="">{{computedPreview}}</span>
                    </div>
                    <p class="mb-2 text-primary preview-text" @click="nicknamePreview">미리보기</p>
                  </b-form-group>
                </div>
                <b-form-group
                        label="안내문구" class="mt-3" v-if="preg.pregNicknameEventInfo != null">
                  <b-form-textarea id="pregNicknameGuide"
                                   v-model="preg.pregNicknameEventInfo.guide"
                                   :rows="3"
                                   :max-rows="6">
                  </b-form-textarea>
                </b-form-group>

                <b-form-group
                        label="닉네임 입력시 안내문구"
                        class="mt-3" v-if="preg.pregNicknameEventInfo != null">
                  <b-form-textarea id="pregNicknameInputGuide"
                                   v-model="preg.pregNicknameEventInfo.inputGuide"
                                   :rows="3"
                                   :max-rows="6">
                  </b-form-textarea>
                </b-form-group>
              </div>
            </b-form-group>

            <div v-show="this.isUsingNicknamePreemption==='y'">
              <b-form-group
                      description=""
                      label="닉네임 선점 시작 알림 메시지"
                      :label-class="labelClasses" v-if="this.isInhouseLogin()">
                <b-form-group label="이미지">
                  <div style="width: 336px;">
                    <vue-dropzone ref="pregNicknameTmsImage" id="pregNicknameTmsImage" :options="Object.assign({}, dropzoneOptions, {clickable: ['#pregNicknameTmsImage', '#nicknameTmsImageUploadBtn'], maxFilesize: 0.3, renameFile: renameAndSetDtoProperty.bind(this, { name: 'tmsImage', imageObj: 'pregNicknameEventInfo' }), accept: acceptHandlingForDimensionLimit.bind(this, 720, 630, '닉네임 선점 시작 알림 메시지')})" v-on:vdropzone-success="imgSuccessHandling"
                                  v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-error="imgErrorHandling" v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" v-on:vdropzone-sending="$refs['pregNicknameTmsImage'].removeAllFiles(false);$refs['pregNicknameTmsImage'].setOption('maxFiles', null)" class="mb-2"></vue-dropzone>
                    <span class="hilight">720 x 630, 300kb 이하</span>
                  </div>
                  <div>
                    <b-button type="button" :id="'nicknameTmsImageUploadBtn'">upload</b-button>
                    <b-button type="button" :href="preg.pregNicknameEventInfo.tmsImage" v-if="preg.pregNicknameEventInfo != null && preg.pregNicknameEventInfo.tmsImage" class="ml-3" target="_blank">download</b-button>
                  </div>
                </b-form-group>

                <b-form-group
                        label="내용" v-if="preg.pregNicknameEventInfo != null">
                  <div style="position: relative; padding-right: 90px">
                    <b-form-textarea id="pregNicknameInputGuide"
                                     v-model="preg.pregNicknameEventInfo.tmsMsg"
                                     @input="limitInputByMaxByte($event, preg.pregNicknameEventInfo, 'tmsMsg', 255)"
                                     :rows="3"
                                     :max-rows="6">
                    </b-form-textarea>
                    <span style="position: absolute; right:0; bottom:0">({{calcCharacterByte(preg.pregNicknameEventInfo.tmsMsg)}}/255bytes)</span>
                  </div>
                </b-form-group>

              </b-form-group>
            </div>

            <b-form-group
              description=""
              label="사전예약 스크린샷 (KO/EN/JP/CH)"
              :label-class="labelClasses" :state="detailScreenShotImagesKoState"
              invalid-feedback="사전예약 스크린샷을 추가하세요.">
              <b-form-group class="d-inline-block mb-0"
                            label="이미지" label-for="detailScreenShotImagesKo">
              </b-form-group>
              <vue-dropzone ref="detailScreenShotImages" id="detailScreenShotImagesKo" :options="Object.assign({}, dropzoneOptions, {clickable: ['#detailScreenShotImagesKo', '#detailScreenShotImagesKoUploadBtn'], maxFilesize: 0.15, maxFiles:5, renameFile: renameAndSetDtoProperty.bind(this, { lang: 'ko', name: 'detailScreenShotImages', imageObj: 'viewInfo'}), isMultiple: true, accept: acceptHandlingForDimensionLimit.bind(this, 600, 1066, '사전예약 스크린샷')})" v-on:vdropzone-success="imgSuccessHandling"
                            v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-error="imgErrorHandling" v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" class="mb-2"></vue-dropzone>
              <span class="hilight">600 x 1066, 150kb 이하</span><br>
              <b-button type="button" :id="'detailScreenShotImagesKoUploadBtn'">upload</b-button>
              <ol>
                <li v-for="(imageUrl, index) in preg.viewInfo.detailScreenShotImages.ko" style="list-style: none">
                  {{ index + 1}} 번째 이미지 <b-button type="button" :href="imageUrl" v-if="imageUrl" class="ml-3" target="_blank">download</b-button>
                </li>
              </ol>
            </b-form-group>

            <b-form-group
              description=""
              label="사전예약 동영상 (KO/EN/JP/CH)"
              :label-class="labelClasses" :state="nameState"
              invalid-feedback="제목을 입력하세요.">
              <b-form-radio-group v-model="detailMovieAddrSelected">
                <b-form-radio value="n" v-on:change="removeProperty(preg.viewInfo.detailMovieAddr, 'ko')">없음</b-form-radio>
                <b-form-radio value="y">동영상 링크</b-form-radio>
                <b-form-input id="detailTopBgColor" type="text" v-model="preg.viewInfo.detailMovieAddr.ko" autocomplete="address" :class="` d-inline-block w-50 align-middle mr-1`" placeholder="" v-if="detailMovieAddrSelected==='y'"></b-form-input>
                <!--<b-form-radio value="kakaoTv">카카오TV 동영상</b-form-radio>-->
              </b-form-radio-group>
              <p> * 입력 예시: 카카오TV (https://tv.kakao.com/v/3916328), 유투브 (https://youtu.be/IOC_QMUQHJQ)</p>
            </b-form-group>

            <b-form-group
              description=""
              label="공유하기 (카카오톡)"
              :label-class="labelClasses">
              <b-form-group class="d-inline-block mb-0"
                            label="이미지" label-for="kakaoTalkShareImage" :state="kakaoTalkShareImageState" invalid-feedback="카카오톡 공유 이미지를 입력해주세요.">
                <div style="width: 336px;">
                  <vue-dropzone ref="kakaoTalkShareImage" id="kakaoTalkShareImage" :options="Object.assign({}, dropzoneOptions, {clickable: ['#kakaoTalkShareImage', '#kakaoTalkShareImageUploadBtn'], maxFilesize: 0.15, renameFile: renameAndSetDtoProperty.bind(this, { name: 'kakaoTalkShareImage', imageObj: 'sharingInfo' }), accept: acceptHandlingForDimensionLimit.bind(this, 720, 630, '카카오톡 공유하기 이미지')})" v-on:vdropzone-success="imgSuccessHandling"
                                v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-error="imgErrorHandling" v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" class="mb-2" v-on:vdropzone-sending="$refs['kakaoTalkShareImage'].removeAllFiles(false);$refs['kakaoTalkShareImage'].setOption('maxFiles', null)"></vue-dropzone>
                  <span class="hilight">720 x 630, 150kb 이하</span>
                </div>
                <div>
                  <b-button type="button" :id="'kakaoTalkShareImageUploadBtn'">upload</b-button>
                  <b-button type="button" :href="preg.sharingInfo.kakaoTalkShareImage" v-if="preg.sharingInfo.kakaoTalkShareImage" class="ml-3" target="_blank">download</b-button>
                </div>
              </b-form-group>
              <b-form-group label="내용" label-for="preg.kakaoTalkShareMsg" :state="kakaoTalkShareMsgState" invalid-feedback="카카오톡 공유하기 메시지를 입력해주세요.">
                <div style="position: relative; padding-right: 90px">
                  <b-form-input id="preg.kakaoTalkShareMsg"
                                   :value="preg.sharingInfo.kakaoTalkShareMsg"
                                   @input="limitInputByMaxByte($event, preg.sharingInfo, 'kakaoTalkShareMsg')">
                  </b-form-input>
                  <span style="position: absolute; right:0; bottom:0">({{calcCharacterByte(preg.sharingInfo.kakaoTalkShareMsg)}}/65bytes)</span>
                </div>
              </b-form-group>
            </b-form-group>

            <b-form-group
              description=""
              label="공유하기 (페이스북) (KO/EN/JP/CH)"
              :label-class="labelClasses"
              invalid-feedback="제목을 입력하세요.">
              <b-form-group class="d-inline-block mb-0"
                            label="이미지" label-for="facebookShareMsg" :state="facebookShareImageKoState" invalid-feedback="페이스북 공유 이미지를 업로드해주세요.">
                <div style="width: 336px;">
                  <vue-dropzone ref="facebookShareImageKo" id="facebookShareImageKo" :options="Object.assign({}, dropzoneOptions, {clickable: ['#facebookShareImageKo', '#facebookShareImageKoUploadBtn'], maxFilesize: 1.0, renameFile: renameAndSetDtoProperty.bind(this, { lang: 'ko', name: 'facebookShareImage', imageObj: 'sharingInfo' }), accept: acceptHandlingForDimensionLimitByObj.bind(this, [{ width: 1200, height: 630 }, {width: 1200, height: 628}, {width: 1800, height: 942}], '페이스북 공유 이미지')})" v-on:vdropzone-success="imgSuccessHandling"
                                v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-error="imgErrorHandling" v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" class="mb-2" v-on:vdropzone-sending="$refs['facebookShareImageKo'].removeAllFiles(false);$refs['facebookShareImageKo'].setOption('maxFiles', null)"></vue-dropzone>
                  <span class="hilight">1200 x 630, 150kb 이하</span>
                </div>
                <div>
                  <b-button type="button" :id="'facebookShareImageKoUploadBtn'">upload</b-button>
                  <b-button type="button" :href="preg.sharingInfo.facebookShareImage.ko" v-if="preg.sharingInfo.facebookShareImage.ko" class="ml-3" target="_blank">download</b-button>
                </div>
              </b-form-group>
              <b-form-group label="내용" label-for="preg.facebookShareMsg" :state="facebookShareMsgKoState" invalid-feedback="페이스북 공유하기 메시지를 입력해주세요.">
                <div style="position: relative; padding-right: 90px">
                  <b-form-textarea id="preg.facebookShareMsg"
                                   :value="preg.sharingInfo.facebookShareMsg.ko"
                                   @input="limitInputByMaxByte($event, preg.sharingInfo.facebookShareMsg, 'ko')"
                                   :rows="3"
                                   :max-rows="6">
                  </b-form-textarea>
                  <span style="position: absolute; right:0; bottom:0">({{calcCharacterByte(preg.sharingInfo.facebookShareMsg.ko)}}/65bytes)</span>
                </div>
              </b-form-group>
            </b-form-group>

            <b-form-group
              description=""
              label="출시알림 메시지"
              :label-class="labelClasses"
              invalid-feedback="제목을 입력하세요.">
              <b-form-group class="d-inline-block mb-0"
                            label="이미지" label-for="openTmsImage" :state="openTmsImageState" invalid-feedback="출시알림 이미지를 업로드해주세요.">
                <div style="width: 336px;">
                  <vue-dropzone ref="openTmsImage" id="openTmsImage" :options="Object.assign({}, dropzoneOptions, {clickable: ['#openTmsImage', '#openTmsImageUploadBtn'], maxFilesize: 0.3, renameFile: renameAndSetDtoProperty.bind(this, {name: 'openTmsImage', imageObj: 'releaseMsgInfo'}), accept: acceptHandlingForDimensionLimit.bind(this, 720, 630, '출시알림 이미지')})" v-on:vdropzone-success="imgSuccessHandling"
                                v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-error="imgErrorHandling" v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" class="mb-2" v-on:vdropzone-sending="$refs['openTmsImage'].removeAllFiles(false);$refs['openTmsImage'].setOption('maxFiles', null)"></vue-dropzone>
                  <span class="hilight">720 x 630, 300kb 이하</span>
                  <div>
                    <b-button type="button" :id="'openTmsImageUploadBtn'">upload</b-button>
                    <b-button type="button" :href="preg.releaseMsgInfo.openTmsImage" v-if="preg.releaseMsgInfo.openTmsImage" class="ml-3" target="_blank">download</b-button>
                  </div>
                </div>
              </b-form-group>
              <b-form-group label="내용" label-for="openTmsMsg" :state="openTmsMsgState" invalid-feedback="출시알림 메시지를 입력해주세요.">
                <div style="position: relative; padding-right: 90px">
                  <b-form-textarea id="openTmsMsg"
                                   :value="preg.releaseMsgInfo.openTmsMsg"
                                   @input="limitInputByMaxByte($event, preg.releaseMsgInfo, 'openTmsMsg', 255)"
                                   :rows="3"
                                   :max-rows="6">
                  </b-form-textarea>
                  <span style="position: absolute; right:0; bottom:0">({{calcCharacterByte(preg.releaseMsgInfo.openTmsMsg)}}/255bytes)</span>
                </div>
              </b-form-group>
            </b-form-group>

            <b-form-group
              description=""
              label="사전 테스트 시작 알림 메시지"
              :label-class="labelClasses" v-show="cbtSelected==='y'">
              <b-form-group class="d-inline-block mb-0"
                            label="이미지" label-for="cbtTmsImage" :state="cbtTmsImageState" invalid-feedback="사전테스트 알림 이미지를 업로드해주세요.">
                <div style="width: 336px;">
                  <vue-dropzone ref="cbtTmsImage" id="cbtTmsImage" :options="Object.assign({}, dropzoneOptions, {clickable: ['#cbtTmsImage', '#cbtTmsImageUploadBtn'], maxFilesize: 0.3, renameFile: renameAndSetDtoProperty.bind(this, {name: 'cbtTmsImage', imageObj: 'cbtMsgInfo'}), accept: acceptHandlingForDimensionLimit.bind(this, 720, 630, '사전 테스트 시작 알림 이미지')})" v-on:vdropzone-success="imgSuccessHandling"
                                v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-error="imgErrorHandling" v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" class="mb-2" v-on:vdropzone-sending="$refs['cbtTmsImage'].removeAllFiles(false);$refs['cbtTmsImage'].setOption('maxFiles', null)"></vue-dropzone>
                  <span class="hilight">720 x 630, 300kb 이하</span>
                </div>
                <div>
                  <b-button type="button" :id="'cbtTmsImageUploadBtn'">upload</b-button>
                  <b-button type="button" :href="preg.cbtMsgInfo.cbtTmsImage" v-if="preg.cbtMsgInfo.cbtTmsImage" class="ml-3" target="_blank">download</b-button>
                </div>
              </b-form-group>
              <b-form-group label="내용" label-for="cbtTmsMsg" :state="cbtTmsMsgState" invalid-feedback="사전테스트 알림 메시지를 입력해주세요.">
                <div style="position: relative; padding-right: 90px">
                  <b-form-textarea id="cbtTmsMsg"
                                   :value="preg.cbtMsgInfo.cbtTmsMsg"
                                   @input="limitInputByMaxByte($event, preg.cbtMsgInfo, 'cbtTmsMsg', 255)"
                                   :rows="3"
                                   :max-rows="6">
                  </b-form-textarea>
                  <span style="position: absolute; right:0; bottom:0">({{calcCharacterByte(preg.cbtMsgInfo.cbtTmsMsg)}}/255bytes)</span>
                </div>
              </b-form-group>
              <b-form-group class="mb-0 mt-2"
                            label="랜딩 URL" label-for="cbtTmsMsg" invalid-feedback="랜딩 URL을 입력하세요." :state="cbtTmsLandingUrlState">
                <b-form-input id="cbtTmsLandingUrl" type="text" autocomplete="url" v-model="preg.cbtMsgInfo.cbtTmsLandingUrl" :class="` w-50 align-middle mr-1`"
                              placeholder="http:// 혹은 https://로 시작해주세요." :state="cbtTmsLandingUrlState"></b-form-input>
              </b-form-group>
            </b-form-group>

            <b-form-group
              description=""
              label="사전예약 리스트 / 사전예약 카드 공통 (KO/EN/JP/CH)"
              :label-class="labelClasses"
              invalid-feedback="">
              <b-form-group class="d-inline-block mb-0"
                            label="이미지" label-for="listIconImage.ko">
              </b-form-group>
              <div style="width: 336px;">
                <vue-dropzone ref="listIconImageKo" id="listIconImageKo" :options="Object.assign({}, dropzoneOptions, {clickable: ['#listIconImageKo', '#listIconImageKoUploadBtn'], maxFilesize: 0.05, renameFile: renameAndSetDtoProperty.bind(this, { lang: 'ko', name: 'listIconImage', imageObj: 'viewInfo'}), accept: acceptHandlingForDimensionLimit.bind(this, 312, 228, '')})" v-on:vdropzone-success="imgSuccessHandling"
                              v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-error="imgErrorHandling" v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" class="mb-2" v-on:vdropzone-sending="$refs['listIconImageKo'].removeAllFiles(false);$refs['listIconImageKo'].setOption('maxFiles', null)"></vue-dropzone>
                <span class="hilight">312 x 228, 50kb 이하</span>
              </div>
              <div>
                <b-button type="button" :id="'listIconImageKoUploadBtn'">upload</b-button>
                <b-button type="button" :href="preg.viewInfo.listIconImage.ko" v-if="preg.viewInfo.listIconImage.ko" class="ml-3" target="_blank">download</b-button>
              </div>
              <b-form-group label="한 줄 요약 (googlePlay)" label-for="listShortDescForAos.ko" horizontal :label-cols="1" class="mt-4" v-if="preg.markets.indexOf('googlePlay') !== -1">
                <div style="position: relative; padding-right: 90px">
                  <b-form-textarea id="listShortDescForAos.ko"
                                   :value="preg.listShortDescForAos.ko"
                                   @input="limitInputByMaxByte($event, preg.listShortDescForAos, 'ko', 45)"
                                   :rows="2"
                                   :max-rows="6" placeholder="45bytes이내, 보상 위주로 짧게">
                  </b-form-textarea>
                  <span style="position: absolute; right:0; bottom:0">({{calcCharacterByte(preg.listShortDescForAos.ko)}}/45bytes)</span>
                </div>
              </b-form-group>
              <b-form-group label="한 줄 요약 (appStore)" label-for="viewInfo.listShortDescForIos.ko" horizontal :label-cols="1" v-if="preg.markets.indexOf('appStore') !== -1">
                <div style="position: relative; padding-right: 90px">
                  <b-form-textarea id="viewInfo.listShortDescForIos.ko"
                                   :value="preg.listShortDescForIos.ko"
                                   @input="limitInputByMaxByte($event, preg.listShortDescForIos, 'ko', 45)"
                                   :rows="2"
                                   :max-rows="6" placeholder="45bytes이내, 홍보 카피 위주로 짧게">
                  </b-form-textarea>
                  <span style="position: absolute; right:0; bottom:0">({{calcCharacterByte(preg.listShortDescForIos.ko)}}/45bytes)</span>
                </div>
                <p class="text-dark">
                  * appStore에는 사전예약 보상 노출 불가, 게임 홍보 카피를 짧게 입력하세요.
                  <br>
                  예시) 사천만을 이어 주는 연결고리, 프렌즈사천성!!
                </p>
              </b-form-group>
            </b-form-group>

            <b-row class="align-items-center mt-3">
              <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
                <b-button block variant="outline-primary" type="submit">수정</b-button>
              </b-col>
              <b-col cols="6" sm="4" m
                     d="2" xl class="mb-3 mb-xl-0">
                <b-button block variant="outline-secondary" v-on:click="$router.go(-1)">뒤로</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import { MODULE_NAME as PREG_MODULE, FETCH_CODES, FETCH_PREG } from '@/store/preg/actions.type'
  import { checkHexColor, checkUrl, noDropAndDropOver, limitInputByMaxByte, getAxiosErrorMessage, shareUrlToEmbedUrl, embedUrlToShareUrl, removeArrElementByValue, validationTemplate,
    calcCharacterByte, convertUnixTimeToDate, $isInhouseLogin, $showModalWithErrorMsg, thumbhnailHandlingForLimtDismension, acceptHandlingForDimensionLimit, acceptHandlingForDimensionLimitByObj } from '@/common/util'
  import { labelClasses, IMAGE_UPLOAD_URL, emoticonChkDesc, genreDesc } from '@/constants'
  import { mapGetters, mapState, mapMutations } from 'vuex'
  import { SHOW_MODAL } from '@/store/ui/mutations.type'
  import pregService from '@/common/api/preg.service'
  import playGameService from '@/common/api/playGame.service'
  const dayElapsedTime = 24 * 60 * 60 * 1000
  const today = new Date()
  const detailCbtNotice = {
    ko: '- 본 테스트는 안드로이드 유저만 참여 가능합니다.\n' +
    '- 사전예약 기간 중 안드로이드 사전예약자를 대상으로 CBT알림이 발송될 수 있습니다.\n' +
    '- 참여자들에게는 테스트 시작일에 개별적으로 메시지가 발송됩니다.'
  }
  export default {
    components: {
      vueDropzone: vue2Dropzone
    },
    data () {
      return {
        isUsingNicknamePreemption: 'n',
        genreDesc: genreDesc,
        isInhouseLogin: $isInhouseLogin.bind(this),
        limitInputByMaxByte: limitInputByMaxByte,
        calcCharacterByte: calcCharacterByte,
        // dropzoneJs 옵션
        dropzoneOptions: {
          paramName: 'image',
          url: process.env.VUE_APP_BASE_URL + IMAGE_UPLOAD_URL,
          dictDefaultMessage: '파일을 선택해주세요.',
          dictRemoveFile: '삭제',
          thumbnailWidth: 250,
          thumbnailHeight: 250,
          thumbnailMethod: 'contain',
          addRemoveLinks: true,
          maxFilesize: 0.5,
          dictFileTooBig: '파일 용량을 초과하였습니다. (최대 용량 : {{maxFilesize}}MB)',
          dictMaxFilesExceeded: '{{maxFiles}}개까지 업로드 가능합니다.',
          dictResponseError: '일시적으로 네트워크 오류가 있습니다. 삭제 후, 다시 시도해주세요.',
          acceptedFiles: 'image/png, image/jpeg'
        },
        // dropzoneJs 옵션
        validationProperties: [],
        // dto
        preg: {
          pregNicknameEventInfo: {
            startTime: null,
            endTime: null
          },
          appMasterId: this.$route.params.appMasterId,
          appInfo: {
            appSdkVer: '',
            capriAppId: '',
            appType: '',
            appName: ''
          },
          cbtMsgInfo: {
            cbtTmsMsg: '',
            cbtTmsImage: '',
            cbtStartDate: null
          },
          markets: [],
          id: 0,
          marketInfoList: [{
            benefitInfo: {
              listShortDescForAos: {
                'ko': ''
              },
              listShortDescForIos: {
                'ko': ''
              }
            },
            startShowTime: null,
            endShowTime: null,
            pregMasterId: 0,
            marketType: '',
            tmsSendingTime: null
          }],
          etcInfo: {
            allowInBoundConn: false,
            cafeTalkAddr: '',
            chatBotId: 0,
            emoticonApiKey: '',
            maxUserCount: 0,
            sampleSnackAddr: '',
            brandPageAddr: ''
          },
          viewInfo: {
            detailAnchorColor: '#f0e313',
            detailCbtNotice: {
              'ko': ''
            },
            detailDesc: {
              'ko': ''
            },
            detailNotice: {
              'ko': ''
            },
            detailMovieAddr: {
              'ko': ''
            },
            detailScreenShotImages: {
              'ko': []
            },
            detailSummary: {
              'ko': ''
            },
            detailTextColor: '',
            detailTopBgColor: '',
            detailTopBgImage: {
              'ko': ''
            },
            detailTopPromoImage: {
              'ko': ''
            },
            instantRegBannerImage: '',
            listIconImage: ''
          },
          releaseMsgInfo: {
            openTmsImage: '',
            openTmsMsg: ''
          },
          sharingInfo: {
            facebookShareImage: {
              'ko': ''
            },
            facebookShareMsg: '',
            kakaoTalkShareImage: '',
            kakaoTalkShareMsg: ''
          },
          type: '',
          name: '',
          startTime: null,
          endTime: null,
          listShortDescForIos: {
            'ko': ''
          },
          listShortDescForAos: {
            'ko': ''
          }
        },
        endTimeFeedBack: '',
        duplicated: null,
        emoticonValidation: null,
        emoticonSelected: 'n',
        sampleSnackSelected: 'n',
        pregUrl: process.env.VUE_APP_PREG_URL,
        cafeTalkSelected: 'n',
        chatBotIdSelected: 'n',
        maxUserCountSelected: 'n',
        detailTopBgColorSelected: '#fff',
        detailAnchorColorSelected: '#cc2105',
        detailMovieAddrSelected: 'n',
        cbtSelected: 'n',
        isTrySubmit: false,
        labelClasses: labelClasses,
        dateOptions: {
          format: 'YYYY-MM-DD HH:mm:ss',
          useCurrent: true
        },
        maxUserCountOptions: [
          { value: 0, text: '선택하세요.' },
          { value: 3, text: '3 명' },
          { value: 1000, text: '1천 명' },
          { value: 3000, text: '3천 명' },
          { value: 5000, text: '5천 명' },
          { value: 10000, text: '1만 명' },
          { value: 20000, text: '2만 명' },
          { value: 30000, text: '3만 명' },
          { value: 50000, text: '5만 명' },
          { value: 100000, text: '10만 명' },
          { value: 200000, text: '20만 명' },
          { value: 300000, text: '30만 명' },
          { value: 500000, text: '50만 명' },
          { value: 1000000, text: '1백만 명' }
        ],
        plusFriendInfo: {},
        isNicknamePreview: false,
      }
    },
    created () {
      // drop, dropOver 이벤트 막음
      noDropAndDropOver()
    },
    mounted () {
      // 종류들에 대한
      this.$store.dispatch(PREG_MODULE + FETCH_CODES)
        .catch($showModalWithErrorMsg.bind(this))
      this.$store.dispatch(PREG_MODULE + FETCH_PREG, this.$route.params.pregId)
        .then((res) => {
          Object.assign(this.preg, JSON.parse(JSON.stringify(this.detail)))

          if (this.preg.etcInfo.plusFriend) {
            this.plusFriendSelectedHandler(this.preg.etcInfo.plusFriend)
          }
          if (this.isInhouseLogin() && this.preg.pregNicknameEventInfo !== null) {
            console.log(this.preg.pregNicknameEventInfo.startTime)
            console.log(convertUnixTimeToDate(this.preg.pregNicknameEventInfo.startTime))
            if (this.preg.pregNicknameEventInfo.startTime != null ) {
              this.preg.pregNicknameEventInfo.startTime = convertUnixTimeToDate(this.preg.pregNicknameEventInfo.startTime)
            }
            if (this.preg.pregNicknameEventInfo.endTime != null ) {
              this.preg.pregNicknameEventInfo.endTime = convertUnixTimeToDate(this.preg.pregNicknameEventInfo.endTime)
            }
            this.isUsingNicknamePreemption = 'y'
            this.$refs.pregNicknameTmsImage.manuallyAddFile(
              {
                pregDtoParam: {
                  lang: '',
                  name: 'banner',
                  uploadUrl: this.preg.pregNicknameEventInfo.tmsImage,
                  isMultiple: false,
                  imageObj: 'pregNicknameEventInfo'
                }}, this.preg.pregNicknameEventInfo.tmsImage)
          }
          embedUrlToShareUrl(this.preg.viewInfo.detailMovieAddr)
          this.preg.startTime = convertUnixTimeToDate(this.preg.startTime)
          this.preg.endTime = convertUnixTimeToDate(this.preg.endTime)
          if (this.preg.cbtMsgInfo !== null) {
            if (this.preg.cbtMsgInfo.cbtStartDate !== null) {
              this.preg.cbtMsgInfo.cbtStartDate = convertUnixTimeToDate(this.preg.cbtMsgInfo.cbtStartDate)
              this.addValidationPropertiesAboutCbt()
            }
          }
          if (this.preg.listShortDescForAos == null) {
            this.preg.listShortDescForAos = {
              'ko': ''
            }
          }
          if (this.preg.listShortDescForIos == null) {
            this.preg.listShortDescForIos = {
              'ko': ''
            }
          }
          // 등록과 동일한 형태로 보내서 수정함
          this.detail.marketInfoList.forEach((item) => {
            this.preg.markets.push(item.marketType)
          })
          for (let lang in this.preg.viewInfo.detailTopBgImage) {
            this.$refs.detailTopBgImage.manuallyAddFile({
              pregDtoParam: {
                lang: lang,
                name: 'detailTopBgImage',
                uploadUrl: this.preg.viewInfo.detailTopBgImage[lang],
                isMultiple: false,
                imageObj: 'viewInfo'
              }}, this.preg.viewInfo.detailTopBgImage[lang])
          }
          for (let lang in this.preg.viewInfo.detailTopPromoImage) {
            this.$refs.detailTopPromoImage.manuallyAddFile({
              pregDtoParam: {
                lang: lang,
                name: 'detailTopPromoImage',
                uploadUrl: this.preg.viewInfo.detailTopPromoImage[lang],
                isMultiple: false,
                imageObj: 'viewInfo'
              }}, this.preg.viewInfo.detailTopPromoImage[lang])
          }
          this.$refs.kakaoTalkShareImage.manuallyAddFile(
            {pregDtoParam: {
                lang: '',
                name: 'kakaoTalkShareImage',
                uploadUrl: this.preg.sharingInfo.kakaoTalkShareImage,
                isMultiple: false,
                imageObj: 'sharingInfo'
              }}, this.preg.sharingInfo.kakaoTalkShareImage)
          for (let lang in this.preg.viewInfo.detailScreenShotImages) {
            for (let i = 0; i < this.preg.viewInfo.detailScreenShotImages[lang].length; i++) {
              this.$refs.detailScreenShotImages.manuallyAddFile({
                pregDtoParam: {
                  lang: lang,
                  name: 'detailScreenShotImages',
                  uploadUrl: this.preg.viewInfo.detailScreenShotImages[lang][i],
                  isMultiple: true,
                  imageObj: 'viewInfo'
                }}, this.preg.viewInfo.detailScreenShotImages[lang][i])
            }
          }
          this.$refs.openTmsImage.manuallyAddFile({
            pregDtoParam: {
              lang: '',
              name: 'openTmsImage',
              uploadUrl: this.preg.releaseMsgInfo.openTmsImage,
              imageObj: 'releaseMsgInfo'
            }}, this.preg.releaseMsgInfo.openTmsImage)
          for (let lang in this.preg.sharingInfo.facebookShareImage) {
            this.$refs.facebookShareImageKo.manuallyAddFile({
              pregDtoParam: {
                lang: lang,
                name: 'facebookShareImage',
                uploadUrl: this.preg.sharingInfo.facebookShareImage[lang],
                imageObj: 'sharingInfo'
              }}, this.preg.sharingInfo.facebookShareImage[lang])
          }
          if (this.preg.cbtMsgInfo.cbtStartDate !== null) {
            this.$refs.cbtTmsImage.manuallyAddFile(
              {pregDtoParam: {
                  lang: '',
                  name: 'cbtTmsImage',
                  uploadUrl: this.preg.cbtMsgInfo.cbtTmsImage,
                  imageObj: 'cbtMsgInfo'
                }}, this.preg.cbtMsgInfo.cbtTmsImage)
          }
          for (let lang in this.preg.viewInfo.listIconImage) {
            this.$refs.listIconImageKo.manuallyAddFile({
              pregDtoParam: {
                lang: lang,
                name: 'listIconImage',
                uploadUrl: this.preg.viewInfo.listIconImage[lang],
                imageObj: 'viewInfo'
              }}, this.preg.viewInfo.listIconImage[lang])
          }
          if (this.preg.viewInfo.detailMovieAddr.ko.trim() === '') {
            this.detailMovieAddrSelected = 'n'
          } else {
            this.detailMovieAddrSelected = 'y'
          }
          if (this.preg.viewInfo.detailAnchorColor === '#cc2105') {
            this.detailAnchorColorSelected = '#cc2105'
          } else if (this.preg.viewInfo.detailAnchorColor === '#f0e313') {
            this.detailAnchorColorSelected = '#f0e313'
          } else if (this.preg.viewInfo.detailAnchorColor === '#003cff') {
            this.detailAnchorColorSelected = '#003cff'
          } else if (this.preg.viewInfo.detailAnchorColor === '#d42cd6') {
            this.detailAnchorColorSelected = '#d42cd6'
          } else {
            this.detailAnchorColorSelected = 'custom'
          }
          if (this.preg.viewInfo.detailTopBgColor === '#fff') {
            this.detailTopBgColorSelected = '#fff'
          } else if (this.preg.viewInfo.detailTopBgColor === '#000') {
            this.detailTopBgColorSelected = '#000'
          } else {
            this.detailTopBgColorSelected = 'custom'
          }
          if (this.preg.etcInfo.maxUserCount === 0) {
            this.maxUserCountSelected = 'n'
          } else {
            this.maxUserCountSelected = 'y'
          }
          if (this.preg.etcInfo.sampleSnackAddr.trim() !== '') {
            this.sampleSnackSelected = 'play'
          } else if (this.preg.etcInfo.brandPageAddr.trim() !== '') {
            this.sampleSnackSelected = 'brand'
          } else {
            this.sampleSnackSelected = 'n'
          }
          if (this.preg.etcInfo.emoticonApiKey.trim() !== '') {
            this.emoticonSelected = 'y'
          } else {
            this.emoticonSelected = 'n'
          }
          if (this.preg.etcInfo.cafeTalkAddr.trim() !== '') {
            this.cafeTalkSelected = 'y'
          } else {
            this.cafeTalkSelected = 'n'
          }
          if (this.preg.cbtMsgInfo.cbtStartDate === null) {
            this.cbtSelected = 'n'
          } else {
            this.cbtSelected = 'y'
          }
          this.setDefaultValidationPropertiesByAuth()
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    watch: {
      isUsingNicknamePreemption (data) {
        if (data === 'y') {
          if (this.preg.pregNicknameEventInfo === null) {
            this.preg.pregNicknameEventInfo = {
              guide: '- 카카오계정당 1개의 캐릭터명만 생성 가능합니다. \n' +
              '- 사전예약을 완료하시면 이후 캐릭터명 선점 시작시 알림메시지가 발송됩니다. \n' +
              '- 사전예약 완료한 이후에만 캐릭터명 선점에 참여가능합니다.',
              inputGuide: '- 2자에서 12자까지 입력해주세요.\n' +
              '- 한글, 영문, 숫자만 입력 가능합니다.\n' +
              '- 금칙어로 등록된 이름이나 단어가 포함된 경우 등록이 불가능할 수 있습니다.\n',
              tmsImage: '',
              tmsMsg: '',
              startTime: null,
              endTime: null,
              speechBubble: null,
            }
          }
          // this.preg.pregNicknameEventInfo = {
            // banner: this.preg.pregNicknameEventInfo.banner || '',
            // floatingBanner: this.preg.pregNicknameEventInfo.floatingBanner || '',
            // guide: this.preg.pregNicknameEventInfo.guide || '- 카카오계정당 1개의 닉네임만 생성 가능합니다. \n' +
            // '- 사전예약을 완료하시면 이후 닉네임 선점 시작시 알림메시지가 발송됩니다. \n' +
            // '- 사전예약 완료한 이후에만 닉네임 선점에 참여가능합니다.',
            // inputGuide: this.preg.pregNicknameEventInfo.inputGuide || '- 2자에서 8자까지 입력해주세요.\n' +
            // '- 한글, 영문, 숫자만 입력 가능합니다.\n' +
            // '- 숫자로 시작하는 닉네임은 생성 불가능합니다.\n'+
            // '- 금칙어로 등록된 이름이나 단어가 포함된 경우\n'+
            // '- 등록이 불가능할 수 있습니다.\n' +
            // '- 닉네임은 서버단위로 중복체크됩니다.',
            // tmsImage: this.preg.pregNicknameEventInfo.tmsImage || '',
            // tmsMsg: this.preg.pregNicknameEventInfo.tmsMsg || '',
            // startTime: this.preg.pregNicknameEventInfo.startTime || null
          // }
        } else {
          this.$refs.pregNicknameTmsImage.removeAllFiles()

          this.preg.pregNicknameEventInfo = {
            guide: '',
            inputGuide: '',
            tmsImage: '',
            tmsMsg: '',
            startTime: null,
            endTime: null,
            speechBubble: null,
          }
        }
      }
    },
    // 다국어 지원 하도록 개편할 때....
    // validation은 라이브러리를 사용하도록..갈아 엎자
    computed: {
      cafeTalkState () {
        // cafeTalkSelected preg.etcInfo.cafeTalkAddr
        return validationTemplate.call(this, () => {
          if (this.cafeTalkSelected === 'y') {
            return !this.isUrl(this.preg.etcInfo.cafeTalkAddr)
          } else {
            return false
          }
        })
      },
      sampleSnackState() {
        // play ==> preg.etcInfo.sampleSnackAddr
        // brand ==>  preg.etcInfo.brandPageAddr
        return validationTemplate.call(this, () => {
          if (this.sampleSnackSelected === 'play') {
            return !this.isUrl(this.preg.etcInfo.sampleSnackAddr)
          } else if (this.sampleSnackSelected === 'brand') {
            return !this.isUrl(this.preg.etcInfo.brandPageAddr)
          } else {
            return false
          }
        })
      },
      endOptions () {
        if (this.preg.startTime !== null) {
          return Object.assign({}, this.dateOptions, {minDate: this.preg.startTime})
        }
        else {
          return this.dateOptions
        }
      },
      detailCbtNoticeKoState () {
        return validationTemplate.call(this, () => {
          return this.preg.viewInfo.detailCbtNotice.ko.trim() === ''
        })
      },
      appMasterIdState () {
        return validationTemplate.call(this, () => {
          return isNaN(this.preg.appMasterId)
        })
      },
      typeState () {
        return validationTemplate.call(this, () => {
          return this.preg.type.trim() === ''
        })
      },
      nameState () {
        return validationTemplate.call(this, () => {
          return this.preg.name.trim() === ''
        })
      },
      marketState () {
        return validationTemplate.call(this, () => {
          return this.preg.markets.length === 0
        })
      },
      startTimeState () {
        return validationTemplate.call(this, () => {
          return this.preg.startTime === null
        })
      },
      endTimeState () {
        return validationTemplate.call(this, () => {
          if (this.preg.endTime === null) {
            this.addProperty(this, 'endTimeFeedBack', '예약 기간을 설정해주세요.')
            return true
          }
          if (this.preg.endTime.getTime() <= this.preg.startTime.getTime()) {
            this.addProperty(this, 'endTimeFeedBack', '종료 시간이 시작 시간 이전일 수 없습니다.')
            return true
          }
          return false
        })
      },
      detailSummaryState () {
        return validationTemplate.call(this, () => {
          return this.preg.viewInfo.detailSummary.ko.trim() === ''
        })
      },
      detailDescKoState () {
        return validationTemplate.call(this, () => {
          return this.preg.viewInfo.detailDesc.ko.trim() === ''
        })
      },
      detailTopBgImageState () {
        return validationTemplate.call(this, () => {
          return this.preg.viewInfo.detailTopBgImage.ko.trim() === ''
        })
      },
      detailTopPromoImageState () {
        return validationTemplate.call(this, () => {
          return this.preg.viewInfo.detailTopPromoImage.ko.trim() === ''
        })
      },
      detailTopBgColorState () {
        return validationTemplate.call(this, () => {
          if (this.detailTopBgColorSelected === 'custom') {
            return !this.isHexColor(this.preg.viewInfo.detailTopBgColor.trim())
          } else {
            return this.preg.viewInfo.detailTopBgColor.trim() === ''
          }
        })
      },
      detailTextColorState () {
        return validationTemplate.call(this, () => {
          return this.preg.viewInfo.detailTextColor.trim() === ''
        })
      },
      detailAnchorColorState () {
        return validationTemplate.call(this, () => {
          if (this.detailAnchorColorSelected === 'custom') {
            return !this.isHexColor(this.preg.viewInfo.detailAnchorColor.trim())
          } else {
            return this.preg.viewInfo.detailAnchorColor.trim() === ''
          }
        })
      },
      detailScreenShotImagesKoState () {
        return validationTemplate.call(this, () => {
          return this.preg.viewInfo.detailScreenShotImages.ko.length === 0
        })
      },
      kakaoTalkShareImageState () {
        return validationTemplate.call(this, () => {
          return this.preg.sharingInfo.kakaoTalkShareImage.trim() === ''
        })
      },
      kakaoTalkShareMsgState () {
        return validationTemplate.call(this, () => {
          return this.preg.sharingInfo.kakaoTalkShareMsg.trim() === ''
        })
      },
      facebookShareImageKoState () {
        return validationTemplate.call(this, () => {
          return this.preg.sharingInfo.facebookShareImage.ko.trim() === ''
        })
      },
      facebookShareMsgKoState () {
        return validationTemplate.call(this, () => {
          return this.preg.sharingInfo.facebookShareMsg.ko.trim() === ''
        })
      },
      openTmsImageState () {
        return validationTemplate.call(this, () => {
          return this.preg.releaseMsgInfo.openTmsImage.trim() === ''
        })
      },
      openTmsMsgState () {
        return validationTemplate.call(this, () => {
          return this.preg.releaseMsgInfo.openTmsMsg.trim() === ''
        })
      },
      cbtTmsImageState () {
        return validationTemplate.call(this, () => {
          return this.preg.cbtMsgInfo.cbtTmsImage.trim() === ''
        })
      },
      cbtTmsMsgState () {
        return validationTemplate.call(this, () => {
          return this.preg.cbtMsgInfo.cbtTmsMsg.trim() === ''
        })
      },
      cbtTmsLandingUrlState () {
        return validationTemplate.call(this, () => {
          return !this.isUrl(this.preg.cbtMsgInfo.cbtTmsLandingUrl.trim())
        })
      },
      codes () {
        return this.$store.state.preg.codes
      },
      computedPreview() {
        if(this.preg.pregNicknameEventInfo.speechBubble) {
          return ` : ${this.preg.pregNicknameEventInfo.speechBubble}`
        }
        const startTime = this.preg.pregNicknameEventInfo.startTime
        const month = startTime.getMonth() + 1
        const date = startTime.getDate()
        const hour = startTime.getHours()
        return ` : ${month}월 ${date}일 ${hour}시부터`
      },
      ...mapGetters('preg', [
        'pregTypeOptionsForBootstrap',
        'marketTypeOptionsForBootstrap'
      ]),
      ...mapState('preg', [
        'detail'
      ]),
      ...mapState('auth', [
        'auth'
      ])
    },
    methods: {
      isUrl(str) {
        return checkUrl(str)
      },
      isHexColor(str) {
        // let regex = /^#(?:[0-9a-f]{6})$/i;
        return checkHexColor(str)
      },
      plusFriendSelectedHandler (val) {
        if (val === true) {
          playGameService.getPlusFriend(this.$route.params.appMasterId)
            .then((res)=> {
              if (!res.data) {
                this[SHOW_MODAL]({msg: '톡채널을 먼저 등록해주세요.', okHandling: ()=> {
                  }})
                this.preg.etcInfo.plusFriend = false
                this.plusFriendInfo = {}
              } else {
                this.plusFriendInfo = res.data
              }
            })
        }
      },
      thumbhnailHandlingForLimtDismension: thumbhnailHandlingForLimtDismension,
      acceptHandlingForDimensionLimit: acceptHandlingForDimensionLimit,
      acceptHandlingForDimensionLimitByObj: acceptHandlingForDimensionLimitByObj,
      emoticonSelectedHandler (val) {
        if (val === 'y') {
          this.addProperty(this, 'validationProperties', 'emoticonValidation')
        } else {
          this.removeProperty(this, 'validationProperties', 'emoticonValidation')
        }
      },
      chkEmoticonValidation () {
        this.preg.etcInfo.emoticonApiKey = this.preg.etcInfo.emoticonApiKey.trim()

        pregService.chkEmoticonValidation(this.preg.etcInfo.emoticonApiKey)
          .then(({data}) => {
            if (Number(data.statusCode) !== 200) {
              this[SHOW_MODAL]({msg: emoticonChkDesc[data.detail_code]['ko'], okHandling: () => {}})
              this.emoticonValidation = false
            } else {
              this.emoticonValidation = true
            }
          })
          .catch($showModalWithErrorMsg.bind(this))
      },
      setDefaultValidationPropertiesByAuth () {
        if (this.isInhouseLogin()) {
          this.validationProperties = this.validationProperties.concat(['typeState', 'nameState', 'marketState',
            'startTimeState', 'endTimeState', 'detailSummaryState', 'detailDescKoState', 'detailTopBgImageState',
            'detailTopPromoImageState', 'detailTopBgColorState', 'detailAnchorColorState', 'detailTextColorState',
            'detailScreenShotImagesKoState', 'kakaoTalkShareImageState', 'kakaoTalkShareMsgState', 'facebookShareImageKoState',
            'facebookShareMsgKoState', 'openTmsImageState', 'openTmsMsgState',
            'sampleSnackState', 'cafeTalkState'])
        } else {
          // 비즈 계정
          this.validationProperties = this.validationProperties.concat(['detailSummaryState', 'detailDescKoState', 'detailTopBgImageState',
            'detailTopPromoImageState', 'detailTopBgColorState', 'detailAnchorColorState', 'detailTextColorState',
            'detailScreenShotImagesKoState', 'kakaoTalkShareImageState', 'kakaoTalkShareMsgState', 'facebookShareImageKoState',
            'facebookShareMsgKoState', 'openTmsImageState', 'openTmsMsgState'])
        }
      },
      resetCbt (lang) {
        this.preg.viewInfo.detailCbtNotice[lang] = ''
        this.preg.cbtMsgInfo.cbtStartDate = null
        this.$refs.cbtTmsImage.removeAllFiles()
        this.preg.cbtMsgInfo.cbtTmsImage = ''
        this.preg.cbtMsgInfo.cbtTmsMsg = ''
        this.preg.cbtMsgInfo.cbtTmsLandingUrl = ''
        console.log('resetCbt')
        this.removeProperty(this, 'validationProperties', 'cbtTmsImageState')
        this.removeProperty(this, 'validationProperties', 'cbtTmsMsgState')
        this.removeProperty(this, 'validationProperties', 'cbtTmsLandingUrlState')
        this.removeProperty(this, 'validationProperties', 'detailCbtNoticeKoState')
      },
      setDefaultCbt (lang) {
        console.log(detailCbtNotice)
        this.preg.viewInfo.detailCbtNotice[lang] = detailCbtNotice[lang]
        this.preg.cbtMsgInfo.cbtStartDate = new Date()
        this.addValidationPropertiesAboutCbt()
      },
      addValidationPropertiesAboutCbt () {
        this.addProperty(this, 'validationProperties', 'cbtTmsImageState')
        this.addProperty(this, 'validationProperties', 'cbtTmsMsgState')
        this.addProperty(this, 'validationProperties', 'cbtTmsLandingUrlState')
        this.addProperty(this, 'validationProperties', 'detailCbtNoticeKoState')
      },
      getIsTrySubmit () {
        return this.isTrySubmit
      },
      setIsTrySubmit () {
        this.isTrySubmit = true
      },
      checkValidation () {
        console.log('checkValidation')
        this.setIsTrySubmit()
        let isValid = true
        for (let i = 0; i < this.validationProperties.length; i++) {
          if (!this[this.validationProperties[i]]) {
            isValid = false
            console.log(this.validationProperties[i])
          }
        }
        return isValid
      },
      submitHandling (e) {
        if (this.checkValidation()) {
          if (this.emoticonSelected === 'n') {
            this.preg.etcInfo.emoticonApiKey = ""
          }

          let langList = shareUrlToEmbedUrl(this.preg.viewInfo.detailMovieAddr)
          if (this.detailMovieAddrSelected === 'y' && langList.length > 0) {
            alert('동영상 링크를 확인해주세요.');
            return;
          } else if (this.detailMovieAddrSelected === 'n') {
            this.preg.viewInfo.detailMovieAddr.ko = ''
          }
          if (this.isUsingNicknamePreemption === 'n') {
            this.preg.pregNicknameEventInfo = null
          }
          pregService.update(this.preg.id, this.preg)
            .then((res) => {
              this[SHOW_MODAL]({msg: '수정이 완료되었습니다.', okHandling: this.redirectingAfterEnroll})
            })
            .catch((error) => {
              embedUrlToShareUrl(this.preg.viewInfo.detailMovieAddr)
              const errorMsg = getAxiosErrorMessage(error)
              this[SHOW_MODAL]({msg: errorMsg, okHandling: () => {}})
            })
        } else {
          this[SHOW_MODAL]({msg: '입력 값을 확인하세요.', okHandling: () => {}})
        }
      },
      // dropzoneJs 관련 메소드들 입니다.
      // 이미지를 전송하기전에 이미지 이름을 바꾸고, file에 프로퍼티를 설정한다. (file에 프로퍼티를 설정하는 이유는, imgSuccessHandling에서 접근할 수 있는 객체가 file밖에 없기 때문에
      renameAndSetDtoProperty (objDtoParam, file) {
        const objDtoParamDefault = {
          lang: '',
          isMultiple: false,
          name: '',
          // imgSuccesHandling에서 추가됩니다.
          uploadUrl: '',
          imageObj: ''
        }
        file.pregDtoParam = Object.assign({}, objDtoParamDefault, objDtoParam)
        return objDtoParam.name + '.' + file.type.split('/')[1]
      },
      // 에러 핸들링할 필요가 있다면 여기서!!
      imgErrorHandling (file, message, xhr) {
        console.log('error')
        console.log(file)
        console.log(message)
        console.log(xhr)
      },
      // 이미지 전송 완려될때 트리거되는 이벤트의 핸들링 메소드
      imgSuccessHandling (file, response) {
        file.pregDtoParam.uploadUrl = response.desc
        this.imgHandlingTemplate(file, this.addProperty)
      },
      // 필요하다면 여기서 remove 요청을 보낸다.
      imgRemove (file) {
        this.imgHandlingTemplate(file, this.removeProperty)
      },
      imgHandlingTemplate (file, fn) {
        const objDtoParam = file.pregDtoParam
        console.log('--imgHnalindgTemplate')
        console.log(arguments)
        console.log('--imgHnalindgTemplate')
        // console.log(objDtoParam)
        if (objDtoParam.lang !== '') {
          fn(this.preg[objDtoParam.imageObj][objDtoParam.name], objDtoParam.lang, objDtoParam.uploadUrl)
        } else {
          fn(this.preg[objDtoParam.imageObj], objDtoParam.name, objDtoParam.uploadUrl)
        }
      },
      // dropzoneJs 관련 메소드들 입니다.
      addProperty (obj, property, addingValue) {
        console.log('addProperty')
        console.log(arguments)
        console.log('addProperty')
        if (Array.isArray(obj[property])) {
          obj[property].push(addingValue)
        } else {
          obj[property] = addingValue
        }
      },
      removeProperty (obj, property, removeValue) {
        console.log('--removeProperty--')
        console.log(arguments)
        console.log('--removeProperty--')
        if (Array.isArray(obj[property])) {
          try {
            removeArrElementByValue(obj[property], removeValue)
          } catch (e) {
            console.log(e)
          }
        } else {
          if (removeValue === undefined || obj[property] === removeValue) {
            obj[property] = this.getDefaultValueByType(obj[property])
          }
          console.log(obj[property])
        }
      },
      getDefaultValueByType (value) {
        const type = typeof value
        switch (type) {
          case 'boolean': return false
          case 'function': return function () {}
          case 'null': return null
          case 'number': return 0
          case 'object': return {}
          case 'string': return ''
          case 'undefined': return void 0
        }
      },
      redirectingAfterEnroll () {
        this.$router.push({name: 'pregsContents'})
      },
      nicknamePreview() {
        this.isNicknamePreview = !this.isNicknamePreview
      },
      // 말풍선은 20자 이하로 가능
      checkSpeechBubbleLength() {
        if (this.preg.pregNicknameEventInfo.speechBubble.length > 20) {
          this[SHOW_MODAL]({msg: '말풍선은 20자 이하로 입력해주세요.', okHandling: () => {}})
          let speechBubble = this.preg.pregNicknameEventInfo.speechBubble.substring(0, 20)
          this.preg.pregNicknameEventInfo.speechBubble = ''
          this.$nextTick(function() {
            this.preg.pregNicknameEventInfo.speechBubble = speechBubble
          })
        }
      },
      ...mapMutations('ui', [SHOW_MODAL])
    }
  }
</script>
<style scoped>
  p {
    margin: 3px 0 0 0;
  }
  .hilight {
    color: #f00;
  }
  .preview {
    padding: 15px 13px;
    font-size: 1.2rem;
    font-weight: 400;
    font-family: 'Apple SD Gothic Neo', 'Malgun Gothic', '맑은 고딕', sans-serif;
    line-height: 23px;
    display: table-cell;
    border-radius: 6px;
    border: 1px solid #A3A3A3;
    background-color: #fff;
    text-align: center;
    letter-spacing: -0.01em;
    vertical-align: middle;
    box-sizing: border-box;
  }
  .preview-text:hover{
    cursor: pointer;
  }
</style>
